import { Controller } from "@hotwired/stimulus";
import { closeModal, openModal, parentModal } from "../utils/misc";

export default class extends Controller {
  close(event) {
    const modalId = event.params.id;
    closeModal(modalId);
  }

  closeParentModal(event) {
    const modalId = parentModal(event.currentTarget).id;
    closeModal(modalId);
  }

  open(event) {
    openModal(event.params.id);
  }

  closeOnTurboSuccess(event) {
    if (event.detail.success) {
      this.closeParentModal(event);
    }
  }
}
